import React, { useEffect, useRef, useState } from 'react';
import {
  CarouselThumbnailDiv,
  PageCountIndicator,
  SliderNavButton,
  SliderNavDiv, SliderThumbsdiv,
  ThumbnailSlider, ThumbPageCounter,
} from '../Modals/styles';
import { useTranslation } from 'react-i18next';
import { Carousel, Icon } from 'antd';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import { correctBaseUrl } from '../../utils/svgUtils';
import { DESIGN_AREA_TEMPLATES_TAB } from '../../containers/SidebarMenu/translationValues';

const NAMESPACES = ['DESIGN_AREA_TEMPLATES_TAB'];
const PrintTemplatePreview = (props) => {
  const { targetTemplate, currentIndex, isMailTemplates } = props;
  const { t } = useTranslation(NAMESPACES);
  const [slideIndex, setSlideIndex] = useState(0);
  const slider = useRef(null);

  useEffect(() => {
    /*slider.current = props.currentIndex;*/
    if (!isMailTemplates) {
      setSlideIndex(currentIndex);
      setTimeout(() => {
        slider.current.goTo(currentIndex);
      }, 50);
    }
    // eslint-disable-next-line
  }, []);

  const handleNext = () => slider.current.next();
  const handlePrev = () => slider.current.prev();
  const slideSelection = i => {
    setSlideIndex(i);
    slider.current.goTo(i);
  };

  const onChange = id => {
    setSlideIndex(id);
  };

  return (
    <>
      {!isMailTemplates &&
        <PageCountIndicator>
        {t(DESIGN_AREA_TEMPLATES_TAB.PAGE_NUMBER_LABEL.key, DESIGN_AREA_TEMPLATES_TAB.PAGE_NUMBER_LABEL.value, { PageNum: slideIndex + 1 }) + ' ' + targetTemplate.flows.length}
      </PageCountIndicator>
      }
      <ThumbnailSlider className="gallery-player">
        <CarouselThumbnailDiv isMailTemplates={isMailTemplates ? 1 : 0}>
          {isMailTemplates ?
            <div>
              {targetTemplate &&
                <div key={targetTemplate.id} className="preview_img">
                  <img
                    src={targetTemplate.thumbNailUrl ? correctBaseUrl(targetTemplate.thumbNailUrl) : PageNotFoundIllustration}
                    alt="pageObj-thumbnail"
                    className={!targetTemplate.thumbNailUrl ? 'no-thumbnail' : ''}
                  />
                </div>
              }
            </div>
            :
            <>
              <Carousel
                dots={false}
                ref={slider}
                afterChange={onChange}
              >
                {targetTemplate.flows.map(pageObj => {
                  return (
                    <div key={pageObj.pageId}>
                      <img
                        src={pageObj.thumbnail ? correctBaseUrl(pageObj.thumbnail) : PageNotFoundIllustration}
                        alt="pageObj-thumbnail"
                        className={!pageObj.thumbnail ? 'no-thumbnail' : ''}
                      />
                    </div>
                  );
                })}
              </Carousel>
              <SliderNavDiv>
                <SliderNavButton previousbutton="true" onClick={() => handlePrev()}>
                  <Icon type="left" />
                </SliderNavButton>
                <SliderNavButton nextbutton="true" onClick={() => handleNext()}>
                  <Icon type="right" />
                </SliderNavButton>
              </SliderNavDiv>
            </>
          }
        </CarouselThumbnailDiv>
        {!isMailTemplates &&
          <SliderThumbsdiv>
            {targetTemplate.flows.map((pageObj, index) => {
              return (
                <div
                  key={pageObj.pageId}
                  className={`thumbsdiv-child ${slideIndex === index ? 'active' : ''}`}
                  onClick={() => slideSelection(index)}
                >
                  <>
                    <img
                      src={pageObj.thumbnail ? correctBaseUrl(pageObj.thumbnail) : PageNotFoundIllustration}
                      alt="pageObj-thumbnail"
                      className={!pageObj.thumbnail ? 'no-thumbnail' : ''}
                    />
                    <ThumbPageCounter>
                      <div className="page-counter">{t(DESIGN_AREA_TEMPLATES_TAB.PAGE_NUM.key, DESIGN_AREA_TEMPLATES_TAB.PAGE_NUM.value) + ' '} {index + 1}</div>
                    </ThumbPageCounter>
                  </>
                </div>
              );
            })}
          </SliderThumbsdiv>
        }
      </ThumbnailSlider>
    </>
  )
}

export default PrintTemplatePreview;